// eslint-disable-next-line no-restricted-imports
import * as mustache from 'mustache';

export { mustache };
